import { useDisclosure } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { chatIdAtom } from '@/store/gigiChat/ChatAtom'
import { currentFeedbackAtom, feedbackAtom, showFeedbackDrawerAtom, updateFeedbackCallback } from '@/store/gigiChat/Feedback'
import { addNotification } from '@/store/gigiChat/Notifications'

import FeedbackDrawer from './FeedbackDrawer'

const Container = () => {
    const { t } = useTranslation()
    const { open: isOpen, onOpen, onClose } = useDisclosure()
    const [, updateFeedback] = useAtom(feedbackAtom)
    const [chatID] = useAtom(chatIdAtom)
    const [feedback] = useAtom(currentFeedbackAtom)
    const [showDrawer, hideDrawer] = useAtom(showFeedbackDrawerAtom)
    const [comment, setComment] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const handleSendFeedback = () => {
        setIsLoading(true)
        const localFeedback = { ...feedback, comment }
        if (!comment) {
            localFeedback.comment = 'other'
        }
        void updateFeedback([{ chatID, body: localFeedback }]).then(() => {
            updateFeedbackCallback(localFeedback)
            addNotification('success', t('chat.feedback.toast.success'))
            setIsLoading(false)
            closeFeedbackDrawer()
        })
    }

    const closeFeedbackDrawer = () => {
        onClose()
        setComment('')
        hideDrawer(false)
    }

    useEffect(() => {
        if (showDrawer) {
            onOpen()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDrawer])

    return (
        <FeedbackDrawer
            feedbackType={feedback.type}
            handleSendFeedback={handleSendFeedback}
            isLoading={isLoading}
            isOpen={isOpen}
            onChange={setComment}
            onClose={closeFeedbackDrawer}
            comment={comment}
        />
    )
}

export default Container
